import ImgUpload from './ImgUpload.vue'
export default {
  install: function(Vue){
    Vue.component('ImgUpload',ImgUpload)
  }
}